import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: 13px;
  cursor: default;

  .flow {
    border-radius: 12px;
    overflow: hidden;

    &.no-data {
    text-align: center;
    margin-top: 50px;
    opacity: 0.5;
    color: ${(props) => props.theme.colors.text};
    }
  }  

  .bar {
    display: inline-block;
    width: 50%;
    height: 100px;
    padding-top: 40px;
  }

  p {
    text-align: center;
    margin-top: 20px;
  }

  .hidden {
    visibility: hidden;
  }

  .timeline {
    div > p {
      padding-right: 25%;
      text-wrap: nowrap;
    }
  }
`;

const Sub = styled.div<{ $count?: number; }>`
  display: inline-block;
  width: ${(props) => `calc(100% / ${props.$count})`};
  height: 100px;

  div {
    width: 20px;
    display: inline-block;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    
    p {
      margin-left: -5px;
    }

    &.up {
      transform: rotate(-90deg);
    }
    &.mid-up {
      transform: rotate(-45deg);
    }
    &.same {
      transform: rotate(0deg);
    }
    &.mid-down {
      transform: rotate(45deg);
    }
    &.down {
      transform: rotate(90deg);
    }
  }
`;

export default { Wrapper, Sub };
